module.exports = __webpack_public_path__ + "media/images/menu/corvus-7319fdaa2ae150998dde4fa01fdf9424.jpg";